module.exports = __webpack_public_path__ + "static/organicorgangeleaf-c810d97c9f1bc8ba228aaed1264195da.jpeg";